import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';

import '../Resources/dashboard.css';
import Navbar from './navbar.js';
import Sidebar from './sidebar.js';
//import Newcrm_createteam from './newcrm_createteam.js';
import moment from 'moment/moment';
//import Create_customer from '../create_customer';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//import Newcrm_addcustomer from './newcrm_addcustomer.js';
//import Newcrm_createlead from './newcrm_createlead.js';



function Loancrm_loanlogins(){


    const editId=sessionStorage.getItem("EditId00");
  
      //Report Print Function
      const componentRef = useref();
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });
  

    
 // Function to download the data as an Excel file
 const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "data.xlsx");
};



  //console.log
  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



{/* CUSTOMERS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
const[cd_col15_val,setcd_col15_val] = useState(0);//column15
const[cd_col16_val,setcd_col16_val] = useState(0);//column16
const[cd_col17_val,setcd_col17_val] = useState(0);//column17
const[cd_col18_val,setcd_col18_val] = useState(0);//column18

//Variables
const[data,setData] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();


//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);

/*const[filter_lead_stage,setfilter_lead_stage] = useState(); const updatefilter_lead_stage = (event) => { setfilter_lead_stage(event.target.value);}; const[filter_lead_stage_er,setfilter_lead_stage_er]=useState();
const[filter_customer_name,setfilter_customer_name] = useState(); const updatefilter_customer_name = (event) => { setfilter_customer_name(event.target.value);}; const[filter_customer_name_er,setfilter_customer_name_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_lead_date,setfilter_lead_date] = useState('1970-01-01'); const updatefilter_lead_date = (event) => { setfilter_lead_date(event.target.value);}; const[filter_lead_date_er,setfilter_lead_date_er]=useState();
const[filter_lead_status,setfilter_lead_status] = useState(); const updatefilter_lead_status = (event) => { setfilter_lead_status(event.target.value);}; const[filter_lead_status_er,setfilter_lead_status_er]=useState();
const[filter_loan_requirement,setfilter_loan_requirement] = useState(); const updatefilter_loan_requirement = (event) => { setfilter_loan_requirement(event.target.value);}; const[filter_loan_requirement_er,setfilter_loan_requirement_er]=useState();
const[filter_sanction_amount,setfilter_sanction_amount] = useState(); const updatefilter_sanction_amount = (event) => { setfilter_sanction_amount(event.target.value);}; const[filter_sanction_amount_er,setfilter_sanction_amount_er]=useState();
const[filter_share_amount,setfilter_share_amount] = useState(); const updatefilter_share_amount = (event) => { setfilter_share_amount(event.target.value);}; const[filter_share_amount_er,setfilter_share_amount_er]=useState();


/*const[filter_remarks,setfilter_remarks] = us_remarks(); const updatefilter_remarks = (event) => { setfilter_remarks(event.target.value);}; const[filter_remarks_er,setfilter_remarks_er]=us_remarks();
*/
//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

useEffect(()=>{
   
  getData();
  
  },[])
 
 
    
//******************* GET CUSTOMERS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 

   /*const $filter_lead_stage = filter_lead_stage; const $filter_customer_name = filter_customer_name; const $filter_email = filter_email; const $filter_contact = filter_contact; const $filter_lead_date = filter_lead_date;
   const $filter_lead_status = filter_lead_status; const $filter_loan_requirement = filter_loan_requirement; const $filter_sanction_amount = filter_sanction_amount; const $filter_share_amount = filter_share_amount;
   */

 axios.post("loancrm-get-loanlogins-list", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : filter_val,
   Lead_id : editId,
   /*Filter_lead_stage : $filter_lead_stage,
   Filter_customer_name : $filter_customer_name,
  // Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_lead_date : $filter_lead_date,
   Filter_share_status : $filter_lead_status,
   Filter_loan_requirement : $filter_loan_requirement,
   Filter_sanction_amount : $filter_sanction_amount,
   Filter_share_amount : $filter_share_amount,
  // Filter_remarks : $filter_remarks,
   */
   //Code Edits for pagination
   'page' : pageNumber


   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }

  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
  //  setfilter_lead_stage_er(response.data.validatorerror.Filter_lead_stage);
   /* setfilter_customer_name_er(response.data.validatorerror.Filter_customer_name);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_lead_date_er(response.data.validatorerror.Filter_lead_date);
    setfilter_lead_status_er(response.data.validatorerror.Filter_lead_status);
    setfilter_loan_requirement_er(response.data.validatorerror.Filter_loan_requirement);
    setfilter_share_amount_er(response.data.validatorerror.Filter_share_amount);
    setfilter_sanction_amount_er(response.data.validatorerror.Filter_sanction_amount);*/
  //  setfilter_remarks_er(response.data.validatorerror.Filter_remarks);
   
  }

  //Data Violation
  if(response.data.error==102){ 
  
  //  setfilter_lead_stage_er(response.data.filter_lead_stage_er);
  /*  setfilter_customer_name_er(response.data.filter_customer_name_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_lead_date_er(response.data.filter_lead_date_er);
    setfilter_lead_status_er(response.data.filter_lead_status_er);
    setfilter_loan_requirement_er(response.data.filter_loan_requirement_er);
    setfilter_sanction_amount_er(response.data.filter_sanction_amount_er);
    setfilter_share_amount_er(response.data.filter_share_amount_er); */
  //  setfilter_remarks_er(response.data.filter_remarks_er);


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("EditId00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET CUSTOMERS DATA FUNCTION END  ********************//





//bank_name
const[bank_name,setbank_name]=useState();const updatebank_name = (event) => { setbank_name(event.target.value);}; const[bank_name_er,setbank_name_er]=useState();
//branch_address
const[branch_address,setbranch_address]=useState();const updatebranch_address = (event) => { setbranch_address(event.target.value);}; const[branch_address_er,setbranch_address_er]=useState();
//application_amount
const[application_amount,setapplication_amount]=useState();const updateapplication_amount = (event) => { setapplication_amount(event.target.value);}; const[application_amount_er,setapplication_amount_er]=useState();
//sanction_amount
const[sanction_amount,setsanction_amount]=useState();const updatesanction_amount = (event) => { setsanction_amount(event.target.value);}; const[sanction_amount_er,setsanction_amount_er]=useState();
//login_status
const[login_status,setlogin_status]=useState();const updatelogin_status = (event) => { setlogin_status(event.target.value);}; const[login_status_er,setlogin_status_er]=useState();
//date_applied
const[date_applied,setdate_applied]=useState();const updatedate_applied = (event) => { setdate_applied(event.target.value);}; const[date_applied_er,setdate_applied_er]=useState();
//date_result
const[date_result,setdate_result]=useState();const updatedate_result = (event) => { setdate_result(event.target.value);}; const[date_result_er,setdate_result_er]=useState();
//login_remarks
const[login_remarks,setlogin_remarks]=useState();const updatelogin_remarks = (event) => { setlogin_remarks(event.target.value);}; const[login_remarks_er,setlogin_remarks_er]=useState();
//login_number
const[login_number,setlogin_number]=useState();const updatelogin_number = (event) => { setlogin_number(event.target.value);}; const[login_number_er,setlogin_number_er]=useState();
 
//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();
 

  
    

//******************* EDIT LOAN LOGIN FUNCTION START ********************//
function editloanlogin(){

 
    const login_id = sessionStorage.getItem("LOGINID00");

    //Setting Error Variables
    setbank_name_er(" "); setbranch_address_er(" "); setapplication_amount_er(" "); setsanction_amount_er(" "); setlogin_status_er(" "); setdate_applied_er(" "); setdate_result_er(" "); setlogin_remarks_er(" "); 
  
  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))&&((login_id!=null)||(login_id!=" "))){
   
    const $bank_name = document.getElementById("bank_name").value;
    const $branch_address = document.getElementById("branch_address").value;
    const $application_amount = document.getElementById("application_amount").value;
    const $sanction_amount = document.getElementById("sanction_amount").value;
    const $login_status = document.getElementById("login_status").value;
    const $date_applied = document.getElementById("date_applied").value;
    const $date_result = document.getElementById("date_result").value;
    const $login_remarks = document.getElementById("login_remarks").value;
    const $login_number = document.getElementById("login_number").value;

    axios.post("loancrm-update-loanlogin", {
     Log_id:logid,
     Token:token,
     Edit_id: login_id,
     Lead_id : editId,
     Bank_name : $bank_name,
     Branch_address : $branch_address,
     Application_amount : $application_amount,
     Sanction_amount : $sanction_amount,
     Login_status : $login_status,
     Date_applied : moment($date_applied).format('YYYY-MM-DD'),
     Date_result : moment($date_result).format('YYYY-MM-DD'),
     Login_remarks : $login_remarks,
     Login_number : $login_number,
  
   })
   .then((response) => {
    
      console.log(response.data);
      

    //Invalid Entries
   
    if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }
  
    if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
    
    //Invalid Session
    if((response.data.error)==100){ 
        //Remove Session Variables and redirect to login
       sessionStorage.removeItem("logStatus00");
       sessionStorage.removeItem("logId00");
       sessionStorage.removeItem("logToken00");
       sessionStorage.removeItem("EditId00");
       window.location.replace("/");
  
    }
  
     //Validation Errors
   if(response.data.validatorerror){
  
    //setlead_id_er(response.data.validatorerror.Lead_id);
    setbank_name_er(response.data.validatorerror.Bank_name);
    setbranch_address_er(response.data.validatorerror.Branch_address);
    setapplication_amount_er(response.data.validatorerror.Application_amount);
    setsanction_amount_er(response.data.validatorerror.Sanction_amount);
    setlogin_status_er(response.data.validatorerror.Login_status);
    setdate_applied_er(response.data.validatorerror.Date_applied);
    setdate_result_er(response.data.validatorerror.Date_result);
    setlogin_remarks_er(response.data.validatorerror.Login_remarks);
    setlogin_number_er(response.data.validatorerror.Login_number);
  
    return;
  
  }
  //Invalid Entries
  if(response.data.error==102){ 
    
    //setlead_id_er(response.data.lead_id_er);
    setbank_name_er(response.data.bank_name_er);
    setbranch_address_er(response.data.branch_address_er);
    setapplication_amount_er(response.data.application_amount_er);
    setsanction_amount_er(response.data.sanction_amount_er);
    setlogin_status_er(response.data.login_status_er);
    setdate_applied_er(response.data.date_applied_er);
    setdate_result_er(response.data.date_result_er);
    setlogin_remarks_er(response.data.login_remarks_er);
    setlogin_number_er(response.data.login_number_er);
   
    seterror_msg("Cannot Update Loan Login !");  return; }
  
     
  
     //Transaction Entered Successfully
     if(response.data.successvar==1){   document.getElementById("success-card").style.display="block";  }
     //Cannot Add Transaction
     else{  seterror_msg("Cannot Update Lead !!"); }
    
  
  });
  }
   //User not Logedin
   else{
   
   //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("EditId00");
  
     window.location.replace("/");
   
    }
   
   }
    
   //******************* CREATE SALES FUNCTION END ********************//
  
  

 
//******************* DELETE CUSTOMER FUNCTION START ********************//
function deletecustomer(){

  const custId=sessionStorage.getItem("DEditId00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((custId!=null)||(custId!=" "))){
 
 axios.post("newcrm-delete-customer", {
   Log_id:logid,
   Token:token,
   Edit_id:custId,
 })
 .then((response) => {

  //console.log(response);

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("DEditId00");

     window.location.replace("/");
  }

  //Counter Deleted Successfully
   if(response.data.successvar==1){        

      document.getElementById("delete-card").style.display="none";
      document.getElementById("delete-success-card").style.display="block";  
      sessionStorage.removeItem("DEditId");

  }
  
      //Cannot Delete Counter
    else{  
    document.getElementById("delete-card").style.display="none";
    document.getElementById("delete-error-card").style.display="block";   }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("DEditId00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* DELETE CUSTOMER FUNCTION END ********************//







return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | Loan CRM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>


    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">




       <Navbar />
        {/*} partial */}
        <div class="main-panel">


              
          

          <div class="content-wrapper pb-0">

          
              {/* EDIT LOAN LOGIN SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success"> Loan Login Updated Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <a href="loancrm-loanlogins"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* EDIT LOAN LOGIN SUCCESS CARD END */}
    
               

          
        {/*} table row starts here 
        <div class="row">
             
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Products </h4>
                   <h6 class="text-muted">products listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">168</h3>
               </div>
             </div>
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Trainings </h4>
                   <h6 class="text-muted">trainings listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">689</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Orders </h4>
                   <h6 class="text-muted">orders received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Applications </h4>
                   <h6 class="text-muted">applications received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>

           </div>
            table row end here */}

             {/* CREATE TEAM FORM START */}
                    <div class="row">
                        <div class="col-12 grid-margin create-form" id="create-form">
                    {/*}   <Newcrm_addcustomer /> */}
                    
                        </div>
                    </div>
            {/* CREATE TEAM FORM END */}

          
            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">LOAN LOGINS</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                    <p class="m-0"></p>
                  </a>
                </div>
              <a href="/loancrm-create-loanlogin"> <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" >
                  <i class="mdi mdi-plus-circle"></i> Create New Login</button></a> 
              
              </div>
            </div>


            {/* CUSTOMER DETAILS TABLE START */}
                  
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                {/*}    <h4 class="card-title">Customers</h4>
                    <p class="card-description">view customer details
                    </p>*/}


                {/* EDIT LOAN LOGIN FORM START */}
                <div class="row">
                <div class="col-12 grid-margin">
                         


                <div class="card" id="edit-form" style={{display:"none"}}>
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                        //Removing Sessions and Closing Edit Sales Team
                        setbank_name_er(" "); setbranch_address_er(" "); setapplication_amount_er(" "); setsanction_amount_er(" "); setdate_applied_er(" "); setdate_result_er(" "); setlogin_status_er(" "); setlogin_number_er(" "); setlogin_remarks_er(" ");  seterror_msg(" ");
                        setbank_name(" "); setbranch_address(" "); setapplication_amount(" "); setsanction_amount(" "); setdate_applied(" "); setdate_result(" "); setlogin_status(" "); setlogin_number(" "); setlogin_remarks(" "); 
               
                        sessionStorage.removeItem("LOGINID00");
                        document.getElementById("edit-form").style.display="none";
                        sessionStorage.removeItem("EditId00");
                        
                         }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
               
                  <div class="card-body">
                    <h4 class="card-title">Loan Logins</h4>
                    <div class="form-sample">
                      <p class="card-description">manage loan logins from here</p>
                      <code>{error_msg}</code>
                    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Bank Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ICICI Bank" id="bank_name" value={bank_name} onChange={updatebank_name} />
                            <code>{bank_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Branch Address</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="south mall road" id="branch_address" value={branch_address} onChange={updatebranch_address} />
                            <code>{branch_address_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Application Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="500000.00" id="application_amount" value={application_amount} onChange={updateapplication_amount}/>
                              <code>{application_amount_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sanction Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="400000.00" id="sanction_amount" value={sanction_amount} onChange={updatesanction_amount} />
                            <code>{sanction_amount_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date Applied</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control"  id="date_applied" value={date_applied} onChange={updatedate_applied} />
                            <code>{date_applied_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date Sanctioned</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date_result" value={date_result} onChange={updatedate_result} />
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>enter (01-01-1970) if loan not sanctioned</small>
                            <code>{date_result_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Login Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Madhya Pradesh" id="login_status" style={{padding:"1rem"}} value={login_status} onChange={updatelogin_status} >
                              <option value=" ">select login status</option>
                              <option value="applied">applied</option>
                              <option value="under review">under review</option>
                              <option value="approved">approved</option>
                              <option value="rejected">rejected</option>
                              </select>
                              <code>{login_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Login Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="LGN88Y76T" id="login_number" value={login_number} onChange={updatelogin_number} />
                            <code>{login_number_er}</code>
                            </div>
                          </div>
                        </div>      
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Login Remarks</label>
                        <textarea class="form-control" rows="2"  id="login_remarks" value={login_remarks} onChange={updatelogin_remarks} ></textarea>
                        <code>{login_remarks_er}</code>
                      </div>
                          
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editloanlogin}>Update Loan Login</button>
                      
                   
                    </div>
                  </div>
                </div>
                 {/* EDIT LOAN LOGIN FORM END */}

                </div>
                </div>

                         

                  <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                       
                          <div class="dropdown">
                        {/*}   <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                          
                           <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>     */}

                          
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div class="table-responsive"  id="reports" ref={componentRef}>
                      <table class="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}}>Update</th>
                            <th  style={{fontWeight:"bold"}}>Login Id</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c1" hidden={cd_col1_val==1}>Login Number</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c2" hidden={cd_col2_val==1}>Bank Name</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c3" hidden={cd_col3_val==1}>Branch Address</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c4" hidden={cd_col4_val==1}>Application Amount</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c4" hidden={cd_col4_val==1}>Sanction Amount</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c5" hidden={cd_col5_val==1}>Login Status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c6" hidden={cd_col6_val==1}>Date Applied</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c7" hidden={cd_col7_val==1}>Date Sanctioned</th>
                           {/*} <th  style={{fontWeight:"bold"}} id="cd_c8" hidden={cd_col8_val==1}>Login Remarks</th> */}
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>Created</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Last Updated</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Updated By</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Login Remarks</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                       
                        <tr key={curElm.Login_id}>
                            <td id="cd_co1"  hidden={cd_col1_val==1}><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Customer Id and Redirect to Edit
                            sessionStorage.setItem("LOGINID00",curElm.Login_id);
                            //Set Data for the Edit Fields
                         //   document.getElementById("steam_id").value=curElm.Steam_id;//steam_id
                            document.getElementById("login_number").value=curElm.Login_number;//login_number
                            document.getElementById("bank_name").value=curElm.Bank_name;//bank_name
                            document.getElementById("branch_address").value=curElm.Branch_address;//branch_address
                            document.getElementById("application_amount").value=curElm.Application_amount;//application_amount
                            document.getElementById("sanction_amount").value=curElm.Sanction_amount;//sanction_amount
                            document.getElementById("login_status").value=curElm.Login_status;//login_status
                            document.getElementById("date_applied").value=curElm.Date_applied;//date_applied
                            document.getElementById("date_result").value=curElm.Date_result;//date_result
                            document.getElementById("login_remarks").value=curElm.Login_remarks;//login_remarks
                          
                            document.getElementById('edit-form').style.display = 'block'; 
                            }}></i></td> 
                            <td id="cd_co1"  hidden={cd_col1_val==1}>{curElm.Login_id}</td> 
                            <td id="cd_co2"  hidden={cd_col2_val==1}>{curElm.Login_number}</td>
                            <td id="cd_co3"  hidden={cd_col3_val==1}>{curElm.Bank_name}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Branch_address}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Application_amount}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Sanction_amount}</td>
                            <td id="cd_co5"  hidden={cd_col5_val==1}>
                            <label class="badge badge-primary" hidden={(curElm.Login_status=="under review")||(curElm.Login_status=="rejected")||(curElm.Login_status=="approved")}>applied</label>
                            <label class="badge badge-success" hidden={(curElm.Login_status=="applied")||(curElm.Login_status=="rejected")||(curElm.Login_status=="under review")}>approved</label>
                            <label class="badge badge-warning" hidden={(curElm.Login_status=="applied")||(curElm.Login_status=="rejected")||(curElm.Login_status=="approved")}>under review</label>
                            <label class="badge badge-danger" hidden={(curElm.Login_status=="applied")||(curElm.Login_status=="under review")||(curElm.Login_status=="approved")}>rejected</label>
                            </td>
                            <td id="cd_co7"  hidden={cd_col7_val==1}>{curElm.Date_applied}</td> 
                            <td id="cd_co7"  hidden={cd_col7_val==1}>{curElm.Date_result}</td> 
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Date_created}<br/> ({curElm.Time_created})</td>
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Date_updated}<br/> ({curElm.Time_updated})</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Updated_by}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Login_remarks}</td>
                          
                      {/*}      <td id="cd_co17"  hidden={cd_col17_val==1}><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Customer Id for Delete
                            sessionStorage.setItem("DEditId00",curElm.Cid);  document.getElementById('delete-card').style.display = 'block'; }}></i></td> */}
                           </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                       
                         
                        </tbody>
                      </table>
                    </div> 














                        {/* PAGINATION SECTION START */}
                        <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>

                   
                   
                  </div>
                </div>
              </div>
              {/* CUSTOMER DETAILS TABLE END */}


            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
         {/*} <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);


//}
}
export default Loancrm_loanlogins;